export Tabs from './Tabs';
export TabBar from './TabBar';
export Tab from './Tab';



/** WEBPACK FOOTER **
 ** ./src/Tabs/index.js
 **/